<mat-table [dataSource]="dataSub" matSort aria-label="Meeting Occurance List">
  <!-- column definitions -->
  <ng-container matColumnDef="{{ column }}" *ngFor="let column of columns; index as i" class="header-cell">
    <!-- @if (columnConfig[i].sort) { -->
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnConfig[i].label }}</mat-header-cell>
    <!-- } -->
    <!--<th mat-header-cell *matHeaderCellDef [disabled]="!columnConfig[i].sort">{{ columnConfig[i].label }}</th>-->
    <mat-cell *matCellDef="let cell; index as j" [class.is-linkable]="columnConfig[i].linkable">
      @if (columnConfig[i].key === 'parentMeetingOccurrenceKey') {
        <ng-container>
          <a href="javascript: void(0);" (click)="viewAppointment(cell.parentMeetingOccurrenceKey, cell.parentMeetingKey)">
            {{ cell.parentMeetingOccurrenceKey }}
          </a>
        </ng-container>
      }

      @if (columnConfig[i].key === 'startISOFormatted' || columnConfig[i].key === 'endISOFormatted') {
        <ng-container>
          {{ cell[column] }}
        </ng-container>
      }

      <!--
        TODO: 2026-09-22:  This is a hack to get the client name to be a link.  
        The problem is that the columnConfig[i].key is not always 'clientName' when it should be. 
         It is sometimes 'Client Name' or 'client name'.  
         This is because the columnConfig is generated with inconsistent casing when re-navigating to the home page. 
         We can continue to identify the root cause of this; we are not sure why this is occurring.  
         The component should be fixed to return consistent casing, but for now we will just check for either key version.   

            ==>>>>>> @if (columnConfig[i].key === 'clientName') {
         We have no idea how long has this been occurring; it could have been happening since the major Angular upgrade or earlier.
      -->

      @if ( columnConfig[i].key === 'clientName' || columnConfig[i].key === 'Client Name') {
        <ng-container>
          <a href="javascript: void(0);" (click)="viewClient(cell.parentClientKey, cell.parentCaseKey)">
            {{ cell.clientName }}
          </a>
        </ng-container>
      }

      @if (columnConfig[i].key !== 'startISOFormatted' && columnConfig[i].key !== 'endISOFormatted' 
           && columnConfig[i].key !== 'parentMeetingOccurrenceKey' && columnConfig[i].key !== 'clientName') {
        <ng-container>
          {{ cell[column] }}
        </ng-container>
      }
    </mat-cell>
  </ng-container>

  <!-- Header Row-->
  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>

  <!-- Select Record -->
  <mat-row *matRowDef="let cell; columns: columns"></mat-row>
</mat-table>

<!-- No data found -->
<ng-container *transloco="let t;">
  @if (isReady && resultCount < 1) {
    <ng-container>
      <div class="noresult">
        <div class="center"><center><div style="margin-block: 3%">
                  {{ t('NoResultsFound') }}
                </div></center></div>
      </div>
    </ng-container>
  }
</ng-container>